import { render, staticRenderFns } from "./GmbLocationOffer.vue?vue&type=template&id=226b07bc&scoped=true"
import script from "./GmbLocationOffer.vue?vue&type=script&lang=js"
export * from "./GmbLocationOffer.vue?vue&type=script&lang=js"
import style0 from "./GmbLocationOffer.vue?vue&type=style&index=0&id=226b07bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b07bc",
  null
  
)

export default component.exports